import './Toast.scss';
import { useState } from "react";


function ConfirmPopup(props: { message: string, onConfirm: () => void, onCancel: () => void }) {
    const [isOpen, setOpen] = useState(true);
    const { message, onConfirm, onCancel } = props;

    const onCloseClick = () => {
        setOpen(false);
        onCancel();
    }

    if (!isOpen) {
        return <></>
    }

    //<button className="close-button" onClick={onCloseClick}>X</button>
    return <div className={`mafia-toast info-toast`}>
        <div className="mafia-toast-content">{message}</div>
        
        <div className="mafia-toast-footer">
            <button className="confirm-button" onClick={onConfirm}>Yes</button>
            <button className="cancel-button" onClick={onCloseClick}>No</button>
        </div>
    </div>

}

export default ConfirmPopup;